import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import {
  colors,
  typography,
} from '@style-guide/config';

const Title = styled.h2`
  background-color: ${colors.darkBlue};
  padding: 10px;
  width: 100%;
  color: ${colors.white};
  font-size: ${rem('16px', typography.baseFontSize)};
  font-weight: 600;
  letter-spacing: 1px;
`;

Title.displayName = 'Title';

export default Title;
